/**
 * PATH: packages/ai-hub/src/organisation.ts
 * FILE_ID: AIHUB-ORG-CONTEXT-001
 * PURPOSE: Build active-organisation headers for AI Hub network seams.
 * WHY: Tenant context belongs in a server-validated header, never request payloads.
 * FLOW: canonical org cookie/storage -> explicit header or local failure.
 */

import { getOrgCookie } from '@quotech/auth'

export function getActiveOrganisationId(): string {
  const orgCookie = getOrgCookie()
  const cookieId = typeof orgCookie === 'object' ? orgCookie?.id : orgCookie

  if (!cookieId) {
    throw new Error('No active organisation selected. Please choose an organisation.')
  }
  return String(cookieId)
}

export function buildOrganisationHeader(): Record<'X-Organisation-ID', string> {
  return { 'X-Organisation-ID': getActiveOrganisationId() }
}
